import { makeObservable, observable, runInAction } from "mobx";

class AppStore {
  page = "";
  constructor() {
    makeObservable(this, { page: observable });
  }

  setPage(p) {
    runInAction(() => (this.page = p));
  }
}

const appStore = new AppStore();
export default appStore;
